import { render, staticRenderFns } from "./AddDimension.vue?vue&type=template&id=f028acc4&scoped=true&"
import script from "./AddDimension.vue?vue&type=script&lang=js&"
export * from "./AddDimension.vue?vue&type=script&lang=js&"
import style0 from "./AddDimension.vue?vue&type=style&index=0&id=f028acc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f028acc4",
  null
  
)

export default component.exports